import React from "react";
import Swal from "sweetalert2";
import { useHistory, Link } from 'react-router-dom';
import { useForm, Controller } from "react-hook-form";

// Material-UI
import { Button, makeStyles, Container, Grid, Paper, Typography } from "@material-ui/core";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
// Components
import NavbarUser from "../components/NavbarUser";
import Background from "../components/BackgroundPattern";
import TitlePage from "../components/TitlePageUser";
import TextPilih from "../components/TextPilih";
import Footer from "../components/Footer";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh"
  },
  paper: {
    padding: theme.spacing(2),
    margin: theme.spacing(3,10),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(2,0),
    },
  },
  title: {
    margin: theme.spacing(1,0),
    textAlign: "center",
    fontWeight: "bold"
  },
  button: {
    margin: theme.spacing(1),
    display: "block",
    textAlign: "center",
  },
  bgWhite: {
    backgroundColor: "white"
  }
}));

const PilihTest = ( {classes} ) => {
  const { handleSubmit, control } = useForm();
  const history = useHistory();
  const onSubmit = (data) => {
    console.log(data);
    if (data.pilihSoal !== "Pretest") {
      return Swal.fire({
        icon: "error",
        title: "Tes Belum Dimulai",
        text: "Silahkan Pilih Tes yang sedang dilaksanakan",
      });
    } else {
      return history.push('/user/soal/pretest')
    }
  };

  return (
    <Container>
      <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
        <Grid container alignItems="center" spacing={2}>
          <Grid item xs={6} sm={6} md={5}>
            <FormControl className={classes.bgWhite} variant="outlined" margin="normal" required fullWidth>
              <InputLabel id="pilihSoalLabel">{"Pilih Tes"}</InputLabel>
              <Controller
                as={
                  <Select
                    labelId="pilihSoalLabel"
                    id="pilihSoal"
                    label="Pilih Soal"
                  >
                    <MenuItem value="">
                      <em>Pilih Jenis Test </em>
                    </MenuItem>
                    <MenuItem value="Pretest">{"Pretest"}</MenuItem>
                    <MenuItem value="WeeklyTest-1">{"WeeklyTest-1"}</MenuItem>
                    <MenuItem value="WeeklyTest-2">{"WeeklyTest-2"}</MenuItem>
                    <MenuItem value="WeeklyTest-3">{"WeeklyTest-3"}</MenuItem>
                    <MenuItem value="WeeklyTest-4">{"WeeklyTest-4"}</MenuItem>
                    <MenuItem value="Posttest">{"Posttest"}</MenuItem>
                  </Select>
                }
                name="pilihSoal"
                control={control}
                defaultValue=""
                required
              />
            </FormControl>
          </Grid>
          <Grid item xs={5} sm={4} md={3}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              type="submit"
              fullWidth
            >
              {"Pilih"}
            </Button>
          </Grid>
          <Grid item xs={1} sm={2} md={4}></Grid>
        </Grid>
      </form>
    </Container>
  );
};

const Pretest = ( {classes} ) => {
  return (
    <Container>
      <Grid container>
        <Grid item xs={12}>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant="h5" className={classes.title}>
              {"Pretest"}
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              {"1. Waktu Pengerjaan 15 Menit saat klik tombol mulai"}
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              {"2. Soal terdiri dari pilihan ganda dan essai"}
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              {"3. Pastikan koneksi internet lancar sebelum dan saat mengerjakan soal"}
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              {"4. Jawaban otomatis terkirim saat waktu habis"}
            </Typography>
            <section className={classes.button}>
              <Link to="/user/soal/pretest/mulai" style={{textDecoration: "none", color: "white", width: "100%"}}> 
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                >
                    {"Mulai"}
                </Button>
              </Link>
            </section>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  )
}

const UserSoalPretest = () => {
  const classes = useStyles();

  return (
    <section id="soal-pretest" className={classes.container}>
      <Background/>
      <NavbarUser />
      <Container style={{flex: "1"}}>
        <TitlePage text="Tes Pelatihan" />
        <TextPilih text="Pilih Tes Pelatihan yang akan dikerjakan"/>
        <PilihTest classes={classes} />
        <Pretest classes={classes} />
      </Container>
      <Footer />
    </section>
  );
};

export default UserSoalPretest;
